import { Button } from '../Button';
import { styled, css } from 'styled-components';
import { colors, breakpoints } from '../../abstracts';
import { CarouselIndicator } from '../CarouselIndicator';
import { dontForwardProps } from '../../util';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1115jls-0"
})(["position:relative;display:flex;flex-direction:row;", ""], ({
  $edgeItemsPadding
}) => css(["& > .scroll-grid{width:100%;}& > *{padding-inline:", ";& > *{scroll-margin-inline:", ";}}", "{& > *{padding-inline:unset;& > *{scroll-margin-inline:unset;}}}"], $edgeItemsPadding, $edgeItemsPadding, breakpoints.md));
const getCarouselButtonStyles = () => css(["margin:auto 0;opacity:1;visibility:visible;align-self:center;background-color:", ";border-color:", ";transition:all 200ms;border-width:1px;box-shadow:0 1px 4px -1px rgb(0,0,0,0.2);&&&:hover{box-shadow:0 3px 12px -1px rgb(0,0,0,0.2),0 2px 4px -1px rgb(0,0,0,0.12);background-color:", ";}&&&:active{background-color:", ";box-shadow:unset;}&&&:focus{box-shadow:0 1px 4px -1px rgb(0,0,0,0.2);}&:disabled{opacity:0;visibility:hidden;cursor:unset;}"], colors.white, colors.neutralDeep, colors.white, colors.neutralBrightest);
export const CarouselButton = styled(Button).attrs({
  iconSide: 'left',
  variant: 'outline',
  color: 'secondary',
  options: {
    useFigmaStyles: true
  }
}).withConfig({
  componentId: "aui__sc-1115jls-1"
})(["opacity:0;visibility:hidden;cursor:unset;pointer-events:initial;", ";", "{", "}"], props => props.showArrowOnDesktop && !props.isMobile && getCarouselButtonStyles(), breakpoints.md, ({
  showArrowOnMobile,
  isMobile
}) => {
  if (!showArrowOnMobile && isMobile) return;
  return getCarouselButtonStyles();
});
export const CarouselAriaContainer = styled.div.withConfig({
  componentId: "aui__sc-1115jls-2"
})(["position:absolute;width:1px;height:1px;overflow:hidden;"]);
export const ButtonContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1115jls-3"
})(["position:absolute;display:flex;height:100%;z-index:999;pointer-events:none;", " ", ";"], ({
  direction
}) => css(["", ":0;", "{", ":-1rem;}"], direction, breakpoints.md, direction), ({
  direction,
  disabled,
  suggestiveFade
}) => !disabled && suggestiveFade && css(["&::before{height:100%;width:100%;position:absolute;content:'';background:linear-gradient( ", "deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.5) 30%,rgba(255,255,255,1) 95% );z-index:-1;}"], direction === 'right' ? 90 : 270));
export const SpotlightIndicator = styled(CarouselIndicator).attrs({
  contained: true
}).withConfig({
  componentId: "aui__sc-1115jls-4"
})(["position:absolute;bottom:16px;left:50%;transform:translateX(-50%);z-index:999;"]);